import { render, staticRenderFns } from "./SubmissionCard.vue?vue&type=template&id=2647ff24&scoped=true"
import script from "./SubmissionCard.vue?vue&type=script&lang=js"
export * from "./SubmissionCard.vue?vue&type=script&lang=js"
import style0 from "./SubmissionCard.vue?vue&type=style&index=0&id=2647ff24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2647ff24",
  null
  
)

export default component.exports